import React from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import { Menu } from 'antd';
import PropTypes from 'prop-types';

import FactsheetOverview from '../factsheet/FactsheetOverview';
import Tasks from '../../components/Tasks';

const CustomerFactsheetDashboard = (props) => {
  const { url, path } = props.match;
  let selectedKey = 'overview';
  if (props.location.pathname.includes('tasks')) selectedKey = 'tasks';

  return (
    <div>
      <h2>Factsheet Dashboard</h2>
      <Menu
        className="sec-menu"
        selectedKeys={[selectedKey]}
        mode="horizontal"
      >
        <Menu.Item key="overview">
          <Link to={`${url}`}>Overview</Link>
        </Menu.Item>
        {/*<Menu.Item key="tasks">*/}
        {/*<Link to={`${url}/tasks`}>Tasks</Link>*/}
        {/*</Menu.Item>*/}
      </Menu>
      <Switch>
        <Route exact path={`${path}`} component={FactsheetOverview} />
      </Switch>
    </div>
  );
};

CustomerFactsheetDashboard.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default CustomerFactsheetDashboard;



// WEBPACK FOOTER //
// ./src/pages/customer/CustomerFactsheetDashboard.jsx